
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire09fa"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire09fa"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
const $58718ca8f03a6d40$export$a803b6d313acce4 = {
    DECIMAL_NUMBER_REGEX: /^-?\d*\.?\d+$/,
    INTEGER_REGEX: /^-?\d+$/,
    IMAGE_URL_REGEX: /^(http[s]?:\/\/)?([^\/\s]+\.[^\s]+)*(png|jpg|gif|svg|jpeg|webp)$/i,
    ALPHA_NUMERIC_CHARACTER_REGEX: /^(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>~`_+=\-\/\s]*$/
};


let $9844350d13fa78a4$var$formError = {};
/**
 * Validates if the value is empty (consisting only of whitespace characters).
 * @param {Object} params - An object containing key and value to validate.
 * @param {string} params.key - The field identifier.
 * @param {string} params.value - The value of the field to be validated.
 * @returns {string} - An error message if the value is empty, otherwise an empty string.
 */ const $9844350d13fa78a4$export$940076c60c8acb05 = ({ key: key, value: value })=>$9844350d13fa78a4$var$formError[key] = value.trim() === "" ? `${key} is required.` : "";
/**
 * Checks if the value is a number.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {number} params.value - The value of that field.
 * @returns {string} - An error message if the value is not an integer, otherwise an empty string.
 */ const $9844350d13fa78a4$export$ffa3b1cd345d970 = ({ key: key, value: value })=>$9844350d13fa78a4$var$formError[key] = !(0, $58718ca8f03a6d40$export$a803b6d313acce4).INTEGER_REGEX.test(value) ? `${key} must be an integer.` : "";
/**
 * Checks if the value is a number.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {number} params.value - The value of that field.
 * @returns {string} - An error message if the value is not a float, otherwise an empty string.
 */ const $9844350d13fa78a4$export$54409f412ca1ee8b = ({ key: key, value: value })=>$9844350d13fa78a4$var$formError[key] = !(0, $58718ca8f03a6d40$export$a803b6d313acce4).DECIMAL_NUMBER_REGEX.test(value) ? `${key} must be a float.` : "";
/**
 * Checks if the value is a string.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {string} params.value - The value of that field.
 * @returns {string} - An error message if the value is not a string, otherwise an empty string.
 */ const $9844350d13fa78a4$export$d7b0a588f685ba7e = ({ key: key, value: value })=>$9844350d13fa78a4$var$formError[key] = typeof value !== "string" ? `${key} must be a string.` : "";
/**
 * Checks if the value is valid format.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {string} params.value - The value of that field.
 * @returns {string} - An error message if the value is not a valid image URL, otherwise an empty string.
 */ const $9844350d13fa78a4$export$73bd10d4f8e11cb2 = ({ key: key, value: value })=>$9844350d13fa78a4$var$formError[key] = !(0, $58718ca8f03a6d40$export$a803b6d313acce4).IMAGE_URL_REGEX.test(value) ? `Please make sure ${key} ends with .jpg, .png, .gif, .svg, .jpeg or .webp.` : "";
/**
 * Checks if the value does not exceed the maximum value.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {number} params.value - The value of that field.
 * @param {number} params.max - The maximum allowed value.
 * @returns {string} - An error message if the value exceeds the max, otherwise an empty string.
 */ const $9844350d13fa78a4$export$c6317085752e2c4e = ({ key: key, value: value, max: max })=>$9844350d13fa78a4$var$formError[key] = parseFloat(value) > max ? `${key} must not exceed ${max}.` : "";
/**
 * Checks if the value is longer than minimum length.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {string} params.value - The value of that field.
 * @param {number} [params] - The minimum length required.
 * @param {number} [params] - The maximum length required.
 * @returns {string} - An error message if the length requirement is not met, otherwise an empty string.
 */ const $9844350d13fa78a4$export$929c2d4e93746bc6 = ({ key: key, value: value, min: min, max: max })=>{
    const trimmedValue = typeof value === "string" ? value.trim() : value;
    const errorMessage = typeof trimmedValue !== "undefined" && (trimmedValue.length < min || trimmedValue.length > max) ? `${key} must have between ${min} and ${max} characters.` : "";
    $9844350d13fa78a4$var$formError[key] = errorMessage;
};
/**
 * Checks if the value is a positive number.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {number} params.value - The value of that field.
 * @returns {string} - An error message if the value is not a positive number, otherwise an empty string.
 */ const $9844350d13fa78a4$export$d896bf2c50b7d6df = ({ key: key, value: value })=>$9844350d13fa78a4$var$formError[key] = parseFloat(value) <= 0 ? `${key} must be a positive number greater than zero.` : "";
/**
 * Checks the value contains at least one letter and can include letters, numbers, and special characters.
 * @param {Object} params - An object.
 * @param {string} params.key - The field that needs to check.
 * @param {string} params.value - The value of that field.
 * @returns {string} - An error message if the value does not meet the criteria, otherwise an empty string.
 */ const $9844350d13fa78a4$export$ecf4cd672ec0318b = ({ key: key, value: value })=>$9844350d13fa78a4$var$formError[key] = !(0, $58718ca8f03a6d40$export$a803b6d313acce4).ALPHA_NUMERIC_CHARACTER_REGEX.test(value) ? `${key} must contain at least one letter and can include numbers, and special characters.` : "";
/**
 * Validates the product form data.
 * @param {Object} data - The product form data.
 * @returns {Object} An object containing validation results.
 */ const $9844350d13fa78a4$export$ed692cabb252e59b = (validationSchema)=>{
    $9844350d13fa78a4$var$formError = {};
    for(const key in validationSchema){
        const { field: field, value: value, validators: validators } = validationSchema[key];
        $9844350d13fa78a4$export$940076c60c8acb05({
            key: field,
            value: value
        });
        if ($9844350d13fa78a4$var$formError[field] !== "") continue;
        for (const validator of validators){
            if (typeof validator === "function") validator(value);
            if ($9844350d13fa78a4$var$formError[field] !== "") break;
            validator({
                key: field,
                value: value
            });
        }
    }
    return {
        formError: $9844350d13fa78a4$var$formError
    };
};
/**
 * Displays validation errors next to the corresponding form fields.
 * @param {Object} errors - Object containing validation errors.
 * @returns {void}
 */ const $9844350d13fa78a4$export$f126e540b5e55b28 = (formError)=>{
    const errorMsgElements = document.querySelectorAll("[data-field-error]");
    errorMsgElements.forEach((element)=>{
        element.textContent = "";
    });
    for(const key in formError){
        const value = formError[key];
        const errorMsgElement = document.querySelector(`[data-field-error='${key}']`);
        if (errorMsgElement) errorMsgElement.textContent = value;
    }
};
/**
 * Checks if there are any validation errors in the form error object.
 * @param {Object} formError - The object containing validation errors for each form field.
 * @returns {boolean} - True if there are any validation errors, otherwise false.
 */ const $9844350d13fa78a4$export$fc9b147a017efa1b = (formError)=>{
    return Object.values(formError).some((error)=>error !== "");
};



var $isZ2V = parcelRequire("isZ2V");
const $0878acf4b2514b87$export$92a1a3b7554e9387 = {
    ADD: "add",
    EDIT: "edit"
};



var $ez1WD = parcelRequire("ez1WD");

var $kALLN = parcelRequire("kALLN");

var $9St6j = parcelRequire("9St6j");
class $347445c92f48d32b$export$2e2bcd8739ae039 {
    constructor(action){
        this.productService = new (0, $kALLN.default)();
        this.productTemplate = new (0, $9St6j.default)();
        this.action = action;
        this.displayProductForm();
    }
    /**
   * Displays the product form page.
   * @returns {void}
   */ displayProductForm = async ()=>{
        this.productTemplate.toggleIndicator(true);
        let data = {};
        if (this.action === (0, $0878acf4b2514b87$export$92a1a3b7554e9387).EDIT) {
            const productId = new URLSearchParams(window.location.search).get("id");
            if (productId) data = await this.productService.getByID(productId);
        }
        this.productTemplate.renderProductFormPage(data);
        this.productTemplate.toggleIndicator(false);
        this.bindProductForm();
    };
    /**
   * Binds the event listener to the product form.
   */ bindProductForm = ()=>{
        const formElement = document.getElementById("form-content");
        formElement.addEventListener("submit", async (e)=>{
            e.preventDefault();
            this.productTemplate.toggleIndicator(true);
            const formData = this.getFormData();
            const { formError: formError } = (0, $9844350d13fa78a4$export$ed692cabb252e59b)(formData.validationSchema);
            (0, $9844350d13fa78a4$export$f126e540b5e55b28)(formError);
            const hasFormValid = !(0, $9844350d13fa78a4$export$fc9b147a017efa1b)(formError);
            if (!hasFormValid) {
                this.productTemplate.toggleIndicator(false);
                return;
            }
            const product = formData.product;
            let response;
            switch(this.action){
                case (0, $0878acf4b2514b87$export$92a1a3b7554e9387).ADD:
                    response = await this.productService.add(product);
                    if (response.isSuccess) {
                        (0, $isZ2V.default).success((0, $ez1WD.MESSAGES).ADD_PRODUCT_SUCCESS_MESSAGE);
                        this.clearFormFields();
                    } else (0, $isZ2V.default).error((0, $ez1WD.MESSAGES).ADD_PRODUCT_FAILED_MESSAGE);
                    this.productTemplate.toggleIndicator(false);
                    break;
                case (0, $0878acf4b2514b87$export$92a1a3b7554e9387).EDIT:
                    {
                        const productId = new URLSearchParams(window.location.search).get("id");
                        response = await this.productService.edit(productId, product);
                        if (response.isSuccess) (0, $isZ2V.default).success((0, $ez1WD.MESSAGES).EDIT_PRODUCT_SUCCESS_MESSAGE);
                        else (0, $isZ2V.default).error((0, $ez1WD.MESSAGES).EDIT_PRODUCT_FAILED_MESSAGE);
                        this.productTemplate.toggleIndicator(false);
                        break;
                    }
            }
        });
    };
    /**
   * Retrieves form data from input fields and constructs a validation schema.
   * @returns {Object} - Object containing validation schema for form fields.
   */ getFormData = ()=>{
        const productForm = document.getElementById("product-form");
        const nameValue = productForm.querySelector("#name").value;
        const priceValue = productForm.querySelector("#price").value;
        const imageURLValue = productForm.querySelector("#image-url").value;
        const quantityValue = productForm.querySelector("#quantity").value;
        const validationSchema = {
            name: {
                field: "Name",
                value: nameValue,
                validators: [
                    (value)=>(0, $9844350d13fa78a4$export$929c2d4e93746bc6)({
                            key: "Name",
                            value: value,
                            min: 2,
                            max: 50
                        }),
                    (0, $9844350d13fa78a4$export$d7b0a588f685ba7e),
                    (0, $9844350d13fa78a4$export$ecf4cd672ec0318b)
                ]
            },
            price: {
                field: "Price",
                value: priceValue,
                validators: [
                    (value)=>(0, $9844350d13fa78a4$export$c6317085752e2c4e)({
                            key: "Price",
                            value: value,
                            max: 50
                        }),
                    (0, $9844350d13fa78a4$export$54409f412ca1ee8b),
                    (0, $9844350d13fa78a4$export$d896bf2c50b7d6df)
                ]
            },
            imageURL: {
                field: "Image URL",
                value: imageURLValue,
                validators: [
                    (0, $9844350d13fa78a4$export$73bd10d4f8e11cb2)
                ]
            },
            quantity: {
                field: "Quantity",
                value: quantityValue,
                validators: [
                    (value)=>(0, $9844350d13fa78a4$export$c6317085752e2c4e)({
                            key: "Quantity",
                            value: value,
                            max: 10000
                        }),
                    (0, $9844350d13fa78a4$export$ffa3b1cd345d970),
                    (0, $9844350d13fa78a4$export$d896bf2c50b7d6df)
                ]
            }
        };
        const product = {
            name: nameValue,
            price: priceValue,
            imageURL: imageURLValue,
            quantity: quantityValue
        };
        return {
            validationSchema: validationSchema,
            product: product
        };
    };
    /**
   * Clears all input fields in the form.
   */ clearFormFields = ()=>{
        const productForm = document.getElementById("product-form");
        const inputs = productForm.querySelectorAll(".input-form");
        inputs.forEach((input)=>input.value = "");
    };
}



var $8XpGc = parcelRequire("8XpGc");

/**
 * Determines the action to be taken based on the URL parameters.
 * @returns {string} - Returns the appropriate action type, either ACTIONS.EDIT or ACTIONS.ADD.
 */ function $9ba7858602acdc89$var$getActionFromUrl() {
    const productId = new URLSearchParams(window.location.search).get("id");
    document.title = productId ? "Edit product" : "Create a new product";
    return productId ? (0, $0878acf4b2514b87$export$92a1a3b7554e9387).EDIT : (0, $0878acf4b2514b87$export$92a1a3b7554e9387).ADD;
}
var $9ba7858602acdc89$export$2e2bcd8739ae039 = $9ba7858602acdc89$var$getActionFromUrl;


(function() {
    const action = (0, $9ba7858602acdc89$export$2e2bcd8739ae039)();
    const navList = document.querySelector(".nav-list");
    // Initialize the ProductForm with appropriate action (add or edit)
    new (0, $347445c92f48d32b$export$2e2bcd8739ae039)(action);
    // Add event listener to the nav-list to handle clicks on navigation links
    navList.addEventListener("click", (0, $8XpGc.default));
})();


//# sourceMappingURL=product.17b8486e.js.map
